module.exports = import("https://esm.sh/@putout/bundle");;